export enum OrderActionTypes {
    LIST_REQUEST = '@@Order/LIST_REQUEST',
    LIST_SUCCESS = '@@Order/LIST_SUCCESS',
    LIST_ERROR = '@@Order/LIST_ERROR',
    LIST_CLEAR = '@@Order/LIST_CLEAR',

    SELECT = '@@Order/SELECT',
    SELECTED = '@@Order/SELECTED',
    CLEAR_SELECTED = '@@Order/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Order/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Order/CREATE_SUCCESS',
    CREATE_ERROR = '@@Order/CREATE_ERROR',
    
    // READ_REQUEST = '@@Order/READ_REQUEST',
    // READ_SUCCESS = '@@Order/READ_SUCCESS',
    // READ_ERROR = '@@Order/READ_ERROR',

    UPDATE_REQUEST = '@@Order/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Order/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Order/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Order/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Order/DELETE_SUCCESS',
    DELETE_ERROR = '@@Order/DELETE_ERROR',

    DOWNLOAD_REQUEST = '@@Order/DOWNLOAD_REQUEST',
    DOWNLOAD_SUCCESS = '@@Order/DOWNLOAD_SUCCESS',
    DOWNLOAD_ERROR = '@@Order/DOWNLOAD_ERROR',
}

export interface OrderUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
    readonly downloading: boolean
    readonly downloadURL : string
}
